import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getInspectionTypeListQuery = params => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTION_TYPES}?${stringifyParams(params)}`
	);
};

export const getInspectionTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTION_TYPES}?${stringifyParams(queryParams)}`
	);
};

export const getInspectionType = inspection_type_id => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_INSPECTION_TYPE}${inspection_type_id}`
	);
};

export const addNewInspectionTypeApi = inspection_type => {
	return apiClient.create(
		`${INSPECTION_BASE}${url.POST_INSPECTION_TYPE}`,
		inspection_type
	);
};

export const updateInspectionTypeApi = inspection_type => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_INSPECTION_TYPE}${inspection_type._id}`,
		inspection_type
	);
};

export const deleteInspectionTypeApi = inspection_type_id => {
	return apiClient.delete(
		`${INSPECTION_BASE}${url.DELETE_INSPECTION_TYPE}${inspection_type_id}`
	);
};

export const checkInspectionTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${INSPECTION_BASE}${url.CHECK_INSPECTION_TYPE_EXISTS}?${stringifyParams(
				queryParams
			)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
